<template>
  <div>
    <div class="grid gridO" :class="col=='1'?'one-column':''">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["col"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style  lang="scss">
.gridO{
.panel-wrapper{
    border: none !important;
  }
}
</style>
<style lang="scss" scoped="">
.grid {
  display: grid;
  // grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  margin: 10px auto;
  grid-gap: 10px;
  border: none;
  
}
.one-column {
  grid-template-columns: 100%;
}
</style>